import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { FormComponent } from '@portal-core/general/components/form/form.component';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { FormBodyModule } from '@portal-core/general/directives/form/form-body/form-body.module';
import { FormFooterModule } from '@portal-core/general/directives/form/form-footer/form-footer.module';
import { FormHeaderModule } from '@portal-core/general/directives/form/form-header/form-header.module';

@NgModule({
  declarations: [
    FormComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    ReactiveFormsModule,
    LoaderModule,
    FormControlErrorMessageModule,
    MatButtonModule,
    FormHeaderModule,
    FormBodyModule,
    FormFooterModule
  ],
  exports: [
    FormComponent,
    FormHeaderModule,
    FormBodyModule,
    FormFooterModule
  ]
})
export class FormModule { }
